import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';

import { Total, TotalLabel, TotalsRow } from './styled';

export interface IDonationsProps {
  totalCents: number;
  isLoading?: boolean;
}

const Donations: React.FC<IDonationsProps> = ({ isLoading, totalCents }) => {
  const { formatMessage } = useIntl();

  return (
    <TotalsRow>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <TotalLabel>
            {formatMessage({
              id: 'donation',
            })}
          </TotalLabel>
          <Total data-testid="total-donation">
            <Currency amount={totalCents} />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};

export default Donations;
